"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DignityThroughBasicNeeds() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223894" id="building-excellence-into-every-home" className="bg-background text-foreground w-full">
      <div className="flex flex-col lg:flex-row min-h-[90vh] w-full">
        
        {}
        <div className="w-full lg:w-[60%] bg-primary flex flex-col justify-center px-6 py-20 md:px-12 lg:px-20 xl:px-28 relative overflow-hidden">
          {}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
            <div className="absolute -top-[20%] -left-[10%] w-[70%] h-[70%] rounded-full bg-secondary blur-[120px]" />
          </div>

          <div ref={textRef} className={`relative z-10 max-w-3xl transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <h1 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl text-primary-foreground leading-tight mb-8 tracking-tighter uppercase font-black">
              Building <br className="hidden md:block" />
              <span className="text-secondary italic">Excellence</span>
            </h1>
            
            <p className="font-default text-lg md:text-xl text-primary-foreground/80 mb-12 max-w-2xl leading-relaxed">
              Glencross Construction Ltd delivers high-quality domestic buildings with a focus on craftsmanship and reliability. From bespoke property developments to modern extensions, we bring your architectural vision to life.
            </p>
            
            <div className="flex flex-col sm:flex-row flex-wrap gap-5 items-start sm:items-center">
              <Button asChild size="lg" variant="secondary" className="h-14 px-8 text-base rounded-none shadow-none hover:bg-secondary/90 transition-colors font-default uppercase tracking-wider">
                <Link to="/start-your-build">Start Your Build</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="w-full lg:w-[40%] h-[50vh] lg:h-auto relative overflow-hidden bg-muted">
          <div ref={imageRef} className={`absolute inset-0 w-full h-full transition-all duration-[1500ms] ease-out ${isImageVisible ? "scale-100 opacity-100" : "scale-110 opacity-0"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1646431/img/glencross_bespoke_home_exterior.png" alt="Modern bespoke home construction by Glencross" className="w-full h-full object-cover object-center grayscale contrast-125" />
            {}
            <div className="absolute inset-0 bg-gradient-to-t from-primary/90 to-transparent lg:hidden" />
          </div>
        </div>

      </div>
    </section>;
}